import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, finalize, map, tap } from 'rxjs/operators';

import { of } from 'rxjs';
import {
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    updateRecord,
    updateRecordSuccess,
    updateRecordFailure,
    fetchSingleRecord,
    fetchSingleRecordSuccess,
    fetchSingleRecordFail,
    deleteFileRecord,
    deleteFileRecordSuccess,
    deleteFileRecordFailure,
    markReadFailure,
    markReadSuccess,
    markRead,
    fetchUnread,
    fetchUnreadSuccess,
    fetchUnreadFailure,
    markAsDone,
    markAsDoneSuccess,
    markAsDoneFailure
} from './taskboard.action';

import {
    fetchRecordsSuccess as dossiersRecordSuccess,
} from '../Dossier/dossier.action';


import { AlertService } from 'src/app/core/services/alert.service';
import { CrudServerService } from 'src/app/core/services/crud-server.service';
import { RouterService } from 'src/app/core/services/router.service';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { TaskboardTableService } from './taskboard-table.service';
import { DatatableService } from 'src/app/core/services/datatable.service';
import { FileUploadService } from 'src/app/core/services/file-upload.service';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { HelperService } from 'src/app/core/services/helper.service';

@Injectable()
export class TaskboardRecordEffects {

    fetchData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchRecords),
            exhaustMap(() => {
                const url = 'client-taskboard?section='+this.moduleTableService.section+"&selected_dossier="+this.moduleTableService.dossierId;
                return this.crudServerService.fetchTableData(url, this.moduleTableService).pipe(
                    map( (response) => {

                        const data = response.data;
                        const total = data.pagination.total;

                        this.moduleTableService.page = data.pagination.current_page;
                        this.moduleTableService.lastPage = data.pagination.last_page;
                        this.moduleTableService.pagination = this.tableService.getPaginationArray(data.pagination.current_page, data.pagination.last_page)
                        this.moduleTableService.progressCount = data.progress_count;

                        this.moduleTableService.clubs = data.clubs;
                        this.moduleTableService.categories = data.categories;
                        this.moduleTableService.statuses = data.statuses;


                        this.alertService.triggerAlert(response.message, "success");
                        return fetchRecordsSuccess({listData: data.records, total: total});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => fetchRecordsFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    fetchSingle$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchSingleRecord),
            exhaustMap((data: any) => {
                const url = 'client-taskboard/'+data.id+"/edit"+"?member_id="+this.moduleTableService.memberId+"&dossier_id="+this.moduleTableService.dossierId;
                return this.crudServerService.fetchData(url).pipe(
                    map( (response) => {

                        const data = response.data;
                        this.alertService.triggerAlert(response.message, "success");
                        this.store.dispatch(dossiersRecordSuccess({listData: data.dossiers, total: data.dossiers?.length}));

                        return fetchSingleRecordSuccess({dummyId: data.dummyId, singleData: data.task, files: data.files, statuses: data.statuses, categories: data.categories, members: data.members});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                                this.routeService.triggerRoute(null, "/communication/section/progress");
                            }),
                            map(() => fetchSingleRecordFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    updateData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(updateRecord),
            exhaustMap((data:any) => {
                const url = 'client-taskboard-update/'+data.id;
                return this.crudServerService.updateDataPost(url, data.updatedData).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");
                        
                        // if(data.isNew){
                            // if(this.moduleTableService.dossierId != 0){
                            //     this.routeService.triggerRoute(response, "/dossiers/detail/"+this.moduleTableService.dossierId, { activeTab: 'tasks' });
                            // }
                            // else{
                            //     this.routeService.triggerRoute(response, "/communication/section/progress");
                            // }
                        // }
                        this.routeService.triggerRoute(response, "/communication/details/"+data.id);
                        return updateRecordSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => updateRecordFailure({ error })) // Dispatch 
                        )
                    ),

                    finalize(() => {
                        this.helperService.formButtonDisabled = false;
                    })
                )
            })
        )
    );
    
    deleteFileRecord$ = createEffect(() =>
        this.actions$.pipe(
            ofType(deleteFileRecord),
            exhaustMap((data: any) => {
                
                const url = 'task/'+data.taskId+'/delete-file/'+data.id;
                return this.crudServerService.deleteData(url).pipe(
                    map( (response) => {
                        this.uploader.uploadQueue = this.uploader.uploadQueue.filter(f => f.isUploading && !f.isUploaded && !f.isCancelled);
                        this.store.dispatch(fetchSingleRecord({id: data.taskId}));
                        this.alertService.triggerAlert(response.message, "success");
                        // this.routeService.triggerRoute(null, "/communication");
                        return deleteFileRecordSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.uploader.uploadQueue = this.uploader.uploadQueue.filter(f => f.isUploading && !f.isUploaded && !f.isCancelled);
                                this.store.dispatch(fetchSingleRecord({id: data.taskId}));
                            }),
                            map(() => deleteFileRecordFailure({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    markRead$ = createEffect(() =>
        this.actions$.pipe(
            ofType(markRead),
            exhaustMap((data: any) => {
                const url = 'mark-task/'+data.id;
                return this.crudServerService.fetchData(url).pipe(
                    map( (response) => {
                        return markReadSuccess();
                    }),
                    catchError((error) =>
                        of(error).pipe(
                            map(() => markReadFailure({ error }))
                        )
                    )
                )
            })
        )
    );

    markAsDone$ = createEffect(() =>
        this.actions$.pipe(
            ofType(markAsDone),
            exhaustMap((data: any) => {
                const url = 'mark-task-done/'+data.id;
                return this.crudServerService.fetchData(url).pipe(
                    map( (response) => {
                        this.store.dispatch(fetchSingleRecord({ id: data.id }));
                        this.alertService.triggerAlert(response.message, "success");
                        return markAsDoneSuccess();
                    }),
                    catchError((error) =>
                        of(error).pipe(
                            map(() => markAsDoneFailure({ error }))
                        )
                    )
                )
            })
        )
    );

    fetchUnread$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchUnread),
            exhaustMap((data: any) => {
                const url = 'fetch-unread-task/';
                return this.crudServerService.fetchData(url).pipe(
                    map( (response: any) => {
                        
                        this.localStorageService.setItem("task-counter", response);
                        this.moduleTableService.unReadTasks = response;
                        this.moduleTableService.loadRecords(); 
                        return fetchUnreadSuccess();
                    }),
                    catchError((error) =>
                        of(error).pipe(
                            map(() => fetchUnreadFailure({ error }))
                        )
                    )
                )
            })
        )
    );

    constructor(
        private actions$: Actions,
        private crudServerService: CrudServerService,
        private alertService: AlertService,
        private routeService: RouterService,
        private store: Store<RootReducerState>,
        private tableService: DatatableService,
        private moduleTableService: TaskboardTableService,
        private uploader: FileUploadService,
        private localStorageService: LocalStorageService,
        public helperService: HelperService
    ) { }

}